import styled from 'styled-components'
import { IoClose } from 'react-icons/io5'
import AiModalCover from '../assets/img/ai-modal-card.svg'
import { useTranslation } from 'react-i18next'

const AiModalCard: React.FC<{
  visible: boolean
  style?: React.CSSProperties
  onClose?: () => void
  onStartChat?: () => void
}> = ({ visible, style, onClose, onStartChat }) => {
  const { t } = useTranslation()

  return (
    <AiModal isVisible={visible} style={style}>
      <CloseIcon onClick={onClose} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={AiModalCover} alt="AI Assistant" style={{ width: 245, height: 100 }} />
        <AiModalText>
          <span className="title">{t('ai.aiAssistant')}</span>
          <span className="subtitle">{t('ai.aiAssistantDescription')}</span>
        </AiModalText>
      </div>
      <AiModalButton onClick={onStartChat}>{t('ai.startChat')}</AiModalButton>
    </AiModal>
  )
}

const AiModal = styled.div<{ isVisible: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  background: #ffffff;
  box-shadow: 0px -4px 40px rgba(38, 50, 56, 0.16);
  border-radius: 12px;
  z-index: 1000;
  transform: translateY(${(props) => (props.isVisible ? '0' : '100%')});
  transition: transform 0.3s ease-in-out;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 16px;
  }
`

const CloseIcon = styled(IoClose)`
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 24px;
  color: #627680;
  cursor: pointer;

  @media (max-width: 768px) {
    top: 8px;
    right: 8px;
    font-size: 20px;
  }
`

const AiModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    gap: 12px;
  }
`

const AiModalImage = styled.img`
  width: 100px;
  height: auto;
  border-radius: 8px;

  @media (max-width: 768px) {
    width: 80px;
  }
`

const AiModalText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;

  .title {
    font-family: 'Helvetica Neue';
    font-size: 24px;
    font-weight: 400;
    color: #627680;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }

  .subtitle {
    font-family: 'Helvetica Neue';
    font-size: 14px;
    font-weight: 400;
    color: rgba(98, 118, 128, 0.6);
    text-align: center;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`

const AiModalButton = styled.button`
  padding: 12px 24px;
  background: #263238;
  color: #ffffff;
  font-family: 'Helvetica Neue';
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 30px;

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 12px;
  }
`

export default AiModalCard
